module.exports = __webpack_public_path__ + "static/media/Winners.704c38c2.svg";